<template>
	<div class="tw-flex tw-gap-1" :class="customClasses">
		<div
			:class="{
				'tw-border tw-border-gray-300': disabled || !isChecked,
				'tw-cursor-pointer active:tw-ring': !disabled,
			}"
			class="tw-rounded-full tw-ring-gray-400/[.14]"
			:style="{ width: computedSize, height: computedSize }"
		>
			<div
				class="tw-h-full tw-w-full tw-rounded-full tw-transition"
				:class="computedClasses"
				@click="check"
			></div>
		</div>
		<slot name="label" v-bind="{ check }">
			<div v-if="label" class="tw-cursor-pointer" @click="check">{{ label }}</div>
		</slot>
	</div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	modelValue: {},
	value: {},
	size: {
		type: String,
		default: 'md',
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	label: {
		type: String,
		default: '',
	},
    customClasses: {
        type: String,
        default: 'tw-items-center',
    },
});

const emit = defineEmits(['update:modelValue']);

const isChecked = computed(() => {
	if (Array.isArray(props.modelValue)) {
		return props.modelValue.length && props.modelValue[0] === props.value;
	}
	return props.modelValue === props.value;
});

const computedClasses = computed(() => {
	const res = [];
	if (props.disabled || !isChecked.value) {
		res.push('tw-border tw-border-white');
		if (props.disabled) {
			res.push('tw-bg-gray-300');
		}
	} else if (isChecked.value) {
		res.push('tw-border tw-border-brand');
	}
	if (props.disabled || isChecked.value) {
		if (props.size === 'sm') {
			res.push('tw-border-[5px]');
		} else if (props.size === 'md') {
			res.push('tw-border-[6px]');
		} else {
			console.warn('[AppRadio] Unsupported size', props.size);
		}
	}
	return res;
});

const computedSize = computed(() => {
	return sizes[props.size];
});

const check = () => {
	if (props.disabled) return;
	if (Array.isArray(props.modelValue)) {
		emit('update:modelValue', [props.value]);
	} else {
		emit('update:modelValue', props.value);
	}
};

const sizes = {
	sm: '16px',
	md: '20px',
};

defineExpose({
	check,
});
</script>

<style lang="scss" scoped></style>

<style lang="scss" scoped>
@import 'tailwindcss/base';
@import 'tailwindcss/utilities';
</style>
